var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "ruleForm",
    staticStyle: {
      "padding": "0 10%"
    },
    attrs: {
      "model": _vm.from,
      "label-width": "30%"
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "组织架构"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "margin-left": "1px",
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "collapse-tags": "",
      "props": _vm.props
    },
    model: {
      value: (_vm.ruleForm.organize_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "organize_id", $$v)
      },
      expression: "ruleForm.organize_id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "二级分类"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.secondary_id),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "secondary_id", $$v)
      },
      expression: "ruleForm.secondary_id"
    }
  }, _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.secondary_category,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin-left": "-80px"
    },
    attrs: {
      "label": "使用范围"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.ruleForm.date_type),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "date_type", $$v)
      },
      expression: "ruleForm.date_type"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "label-width": "0px"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "30%",
      "background-color": "#006E4B",
      "border": "1px solid #006E4B"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("\n                保存")])], 1)], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a086c6ba","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/system/setter/tabs/tab2_add.vue
// module id = null
// module chunks = 